if (!customElements.get("market-selector")) {
  // Wiazanie w connectedCallback, nie w konstruktorze: przy podmianie sekcji
  // przez innerHTML (zmiana stelaza laduje inny produkt) parser upgraduje
  // element ZANIM sparsuje jego dzieci, wiec querySelector w konstruktorze
  // zwracal null i sypal TypeError przy kazdej podmianie.
  class a extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      const expand = this.querySelector(".market-selector__expand");
      if (!expand) return;
      this._bound = true;
      expand.addEventListener("click", () => {
        expand.setAttribute(
          "aria-expanded",
          expand.getAttribute("aria-expanded") === "false" ? "true" : "false",
        );
      });
    }
  }
  customElements.define("market-selector", a);
}
